import React, { useState } from "react";
import {
  FiClock as Clock,
  FiUsers as Users,
  FiDollarSign as DollarSign,
  FiWifi as Wifi,
  // FiSettings as Settings,
} from "react-icons/fi";

import { SessionWithUsers } from "../../types";
import { SessionHeader } from "./session-header";
import { SessionOverview } from "./sections/overview";
import { ParticipantsSection } from "./sections/participants";
import { FinancialSection } from "./sections/financial-details";
import { ProviderSection } from "./sections/provider-info";
import { ParticipantsActionSection } from "./sections/participant-actions";
import { Section } from "./section";
import { useGetUsersTransactionsQuery } from "src/features/users-transactions/user-transactions.service";
import { FaExchangeAlt as Exchange } from "react-icons/fa";
import { TransactionsSection } from "./sections/transactions";
import { SessionAdminAlert } from "./sections/session-administration";

const SessionInfoPage: React.FC<SessionWithUsers> = ({ session, users }) => {
  const { data: transactions } = useGetUsersTransactionsQuery({
    where: { sessionId: session.id, bookingId: session.bookingIds?.[0] },
  });

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        <SessionAdminAlert session={session} transactions={transactions ?? []} />
        <SessionHeader session={session} />
        <SessionOverview session={session} />

        <Section
          title="Participants"
          icon={<Users className="w-5 h-5 text-blue-600" />}
          gradient="from-green-400 to-emerald-500"
        >
          <ParticipantsSection session={session} users={users} />
        </Section>

        <Section
          title="Financial Information"
          icon={<DollarSign className="w-5 h-5 text-green-600" />}
          gradient="from-purple-400 to-pink-500"
        >
          <FinancialSection session={session} users={users} />
        </Section>

        <Section
          title="Provider Info"
          icon={<Wifi className="w-5 h-5 text-purple-600" />}
          gradient="from-green-400 to-emerald-500"
        >
          <ProviderSection session={session} users={users} />
        </Section>
        <Section
          title="Participants Actions"
          icon={<Clock className="w-5 h-5 text-indigo-600" />}
          gradient="from-purple-400 to-pink-500"
        >
          <ParticipantsActionSection session={session} users={users} />
        </Section>
        {transactions?.length ? (
          <Section
            title="Transactions"
            icon={<Exchange className="w-5 h-5 text-red-600" />}
            gradient="from-indigo-400 to-purple-500"
          >
            <TransactionsSection users={users} transactions={transactions} />
          </Section>
        ) : null}
      </div>
    </div>
  );
};

export default SessionInfoPage;

/* <Section
              title="Administrative Actions"
              icon={<Settings className="w-5 h-5 text-red-600" />}
              isExpanded={expandedSections.actions}
              onToggle={() => toggleSection("actions")}
            >
              <ActionsSection
                session={session}
                users={users}
                transaction={transactions.find((t) => t.type !== "CREDIT")}
              />
            </Section> */
